import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ensureOrderUniqueId, syncOrderSessionFromUrl } from "../utils/orderSession.utils";

export const useOrderSession = () => {
  const [searchParams] = useSearchParams();
  const shopId = searchParams.get("shopId");
  const tagId = searchParams.get("tagId");
  const qrc = searchParams.get("qrc");
  const orderTableId = searchParams.get("orderTableId");

  ensureOrderUniqueId();

  useEffect(() => {
    syncOrderSessionFromUrl({ shopId, tagId, qrc, orderTableId });
  }, [shopId, tagId, qrc, orderTableId]);
};
